import { type Component, type JSX, Match, Suspense, Switch } from "solid-js";
import {
	Spinner,
	type spinnerSizes,
	type spinnerVariants
} from "~/solidJs/shared/ui/atoms/Spinner/Spinner";
import classes from "./SuspenseBlick.module.scss";

type SuspenseBlockProps = {
	children: JSX.Element;
	variant?: spinnerVariants;
	size?: spinnerSizes;
	dark?: boolean;
	fallback?: JSX.Element;
	name?: string;
};
const Skeleton: Component<{ children: JSX.Element }> = (props) => {
	return <div class={classes.skeleton}>{props.children}</div>;
};
export const SuspenseBlock: Component<SuspenseBlockProps> = (props) => {
	return (
		<Suspense
			fallback={
				<Skeleton>
					{props.fallback || <Spinner variant={props.variant} size={props.size} />}
				</Skeleton>
			}
		>
			{props.children}
		</Suspense>
	);
};
type CustomSuspenseBlockProps = {
	isLoading: boolean;
	children: JSX.Element;
	dark?: boolean;
	class?: string;
	fallback?: JSX.Element;
	isFallback?: boolean;
};
export const CustomSuspenseBlock: Component<CustomSuspenseBlockProps> = (props) => {
	return (
		<Switch>
			<Match when={props.isLoading}>
				{props.isFallback ? (
					props.fallback
				) : (
					<Skeleton>
						<Spinner class={props.dark ? classes.spinner : ""} />
					</Skeleton>
				)}
			</Match>
			<Match when={!props.isLoading}>{props.children}</Match>
		</Switch>
	);
};
